export interface PostKeys {
    code?: string;
    accessToken?: string;
    frontendFlag: number;
    localHostUrl?: string;
    token?: string;
    groupIdentifier?: string;
}

export interface PostSignUp {
    email?: string;
    names?: string;
    phone?: string;
    'g-recaptcha-response'?: string;
    token?: string;
    groupIdentifier?: string;
    investigationIdentifier?: string;
    'skip-recaptcha-token'?: string;
}

export interface OAuthState {
    action?: string;
    token?: string;
    groupIdentifier?: string;
    studyIdentifier?: string;
    studyTitle?: string;
    caseIdentifier?: string;
    formIdentifier?: string;
    entryIdentifier?: string;
    mode?: string;
    redirectUrl?: string;
    autoRedirect?: string;
    lang?: string;
    next?: string;
}

/**
 * A study where the person's membership is deactivated, as the sign-in answer names it (users
 * decision 138). `id` is the study's scrambled hex identifier.
 */
export interface DeactivatedStudy {
    id: string;
    name: string;
}

/**
 * What `GET user/:id/sign-in-studies` answers: what the sign-in answer says about the person's studies,
 * read again without signing in (ENG-10321), under the same wire keys.
 */
export interface SignInStudies {
    requiresOnboarding: boolean;
    deactivatedStudies: DeactivatedStudy[];
}

export interface NetworkKeys {
    data?: string;
    uri?: string;
    user?: string;
    unscrambledUser?: string;
    email?: string;
    requiresOnboarding?: boolean;
    /** Sent only when the person holds no study they can view; empty otherwise. */
    deactivatedStudies?: DeactivatedStudy[];
    oauthAccessToken?: string;
}

interface IKeys {
    data?: string;
    key?: string;
    userId?: string;
    email?: string;
    requiresOnboarding?: boolean;
    deactivatedStudies?: DeactivatedStudy[];
    oauthAccessToken?: string;
}

export class Keys {
  data?: string;
  key?: string;
  identifier?: string;
  email?: string;
  requiresOnboarding?: boolean;
  /**
   * The studies the person was deactivated in, when they hold no other. Kept with the keys so `/study`
   * still sends them to `/deactivated` rather than onboarding after a reload.
   */
  deactivatedStudies?: DeactivatedStudy[];

  oauthAccessToken?: string;
  avatar?: string;
  name?: string;

  constructor(keys: IKeys) {
    this.data = keys.data;
    this.key = keys.key;
    this.identifier = keys.userId;
    this.email = keys.email;
    this.requiresOnboarding = keys.requiresOnboarding;
    this.deactivatedStudies = keys.deactivatedStudies;
    this.oauthAccessToken = keys.oauthAccessToken;
  }

  static mapKeys(networkKeys: NetworkKeys) {
    return new Keys({
      data: networkKeys.data,
      key: networkKeys.uri?.split('/')?.pop() ?? '',
      userId: networkKeys.user?.split('/')?.pop() ?? '',
      email: networkKeys.email,
      requiresOnboarding: networkKeys.requiresOnboarding,
      deactivatedStudies: networkKeys.deactivatedStudies,
      oauthAccessToken: networkKeys.oauthAccessToken
    });
  }
}
